import $http from '@/core/services/http.service';
import Endpoints from '@/constants/endpoints';

import { ActionTree } from 'vuex';
import { State } from '@/core/store/general/state';

export interface Actions {
    setOpenNavbar: {  };
    setScrollTop: {  };
}

export const actions: ActionTree<State, any> = {
    setOpenNavbar: ({ commit }, payload) => {
        commit('setNavbarOpen', payload);
    },
    setScrollTop: ({ commit }, payload) => {
        commit('setScrollTop', payload);
    },
    fetchDelegationList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.get(`${Endpoints.delegation}`)
                .then((res) => {
                    const data = res.data;
                    commit('setDelegationList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    fetchAcceptanceBudgetList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http
              .post(`${Endpoints.budgetAcceptanceList}`, payload.dni)
              .then(res => {
                const data = res.data;
                commit("setAcceptanceBudgetList", [data]);
                resolve(data);
              })
              .catch((err:any) => {
                reject(err);
              });
          });
    },
    fetchLocationList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.get(`${Endpoints.location}`)
                .then((res) => {
                    const data = res.data;
                    commit('setLocationList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    setServerError: ({ commit }, payload) => {
        commit('setServerError', payload);
    },
    setClientMainContainerColorWhite: ({commit}) => {
        commit('setClientMainContainerColorWhite');
    },
    setClientMainContainerColorGreyCustom: ({commit}) => {
        commit('setClientMainContainerColorGreyCustom');
    },
    setClientMainContainerColorGreyLight: ({commit}) => {
        commit('setClientMainContainerColorGreyLight');
    },
};
